<template>
  <v-row>
    <v-col cols="12" sm="4" v-if="showInfo">
      <p class="gray--text font-weight-bold quotation-title">
        DADOS
      </p>
    </v-col>
    <v-col cols="12" class="resume-cotation__container">
      <v-row class="pa-5">
        <v-col cols="auto" class="align-self-center">
          <p class="resume-cotation__title mb-0 primary--text">
            RESUMO DA COTAÇÃO
          </p>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
          <BaseButton icon @click="showResumeQuotation()">
            <v-icon color="primary" size="14"> {{ iconShowResume }} </v-icon>
          </BaseButton>
        </v-col>
      </v-row>
      <v-row class="px-8 pt-1 pb-9" v-if="isActiveResume">
        <v-col cols="12" v-if="isClient">
          <v-row v-for="(item, key) in [0, 1, 2, 3]" :key="key">
            <v-col cols="12" sm="5" class="pb-3">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                {{ firstColumnResumeQuotation[item].title }}
              </p>
              <p class="primary--text resume-cotation__title">
                {{ firstColumnResumeQuotation[item].value }}
              </p>
              <v-divider />
            </v-col>
            <v-spacer />
            <v-col cols="12" sm="5" class="pb-3">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                {{ secondColumnResumeQuotation[item].title }}
              </p>
              <p class="primary--text resume-cotation__title">
                {{ secondColumnResumeQuotation[item].value }}
              </p>
              <!-- Não aparecer divider no ultimo -->
              <v-divider v-if="item != 3" />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" sm="5" class="pb-3">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Tipo de Emissão
              </p>
              <p class="primary--text resume-cotation__title">
                {{ typeEmission }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" v-else>
          <v-row>
            <v-col cols="12">
              <p class="primary--text resume-cotation__title">
                TOMADOR MATRIZ/FILIAL
              </p>
            </v-col>
            <v-col cols="12" sm="6" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Nome
              </p>
              <p class="primary--text resume-cotation__title">
                {{ info.tomador.nome_fantasia }}
              </p>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                CNPJ
              </p>
              <p class="primary--text resume-cotation__title">
                {{ BRUtils.formatCNPJ(info.tomador.cnpj) }}
              </p>
            </v-col>
            <v-col cols="12" class="pb-3">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <p class="primary--text resume-cotation__title">
                SEGURADO
              </p>
            </v-col>
            <v-col cols="12" sm="6" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Nome
              </p>
              <p class="primary--text resume-cotation__title">
                {{ info.segurado.nome }}
              </p>
            </v-col>
            <v-col cols="12" sm="6">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                {{ secondColumnResumeQuotation[1].title }}
              </p>
              <p class="primary--text resume-cotation__title">
                {{ secondColumnResumeQuotation[1].value }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                CEP
              </p>
              <p class="primary--text resume-cotation__title">
                {{ zipCodeAddressInsured }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Logradouro
              </p>
              <p class="primary--text resume-cotation__title">
                {{ addressInsured }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Número
              </p>
              <p class="primary--text resume-cotation__title">
                {{ numberAddressInsured }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Complemento
              </p>
              <p class="primary--text resume-cotation__title">
                {{ complementAddressInsured }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                UF
              </p>
              <p class="primary--text resume-cotation__title">
                {{ stateInsured }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Cidade
              </p>
              <p class="primary--text resume-cotation__title">
                {{ cityInsured }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="3" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Bairro
              </p>
              <p class="primary--text resume-cotation__title">
                {{ neighborhoodInsured }}
              </p>
            </v-col>
            <v-col cols="12" class="pb-3">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <p class="primary--text resume-cotation__title">
                OBJETO DO SEGURO
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Tipo de Emissão
              </p>
              <p class="primary--text resume-cotation__title">
                {{ typeEmission }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Tipo do Processo
              </p>
              <p class="primary--text resume-cotation__title">
                {{ typeProcess }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Número do Processo
              </p>
              <p class="primary--text resume-cotation__title">
                {{ numberProcess }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Tribunal
              </p>
              <p class="primary--text resume-cotation__title">
                {{ courtName }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                {{ nameLabelJusticeRegion }}
              </p>
              <p class="primary--text resume-cotation__title">
                {{ justiceRegionName }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Número Interno do Cliente
              </p>
              <p class="primary--text resume-cotation__title">
                {{ internalNumber }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Escritório Responsável
              </p>
              <p class="primary--text resume-cotation__title">
                {{ officeName }}
              </p>
            </v-col>
            <v-col cols="12">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Informações do Contrato
              </p>
              <p class="primary--text resume-cotation__title">
                {{ info.informacoes_contrato || "---" }}
              </p>
            </v-col>
            <v-col cols="12">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Importância Segurada
              </p>
              <p class="primary--text resume-cotation__title">
                {{ asMoneyString(valueQuotation) }}
              </p>
            </v-col>
            <v-col cols="12">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Composição da Impotância Segurada
              </p>
              <p class="primary--text resume-cotation__title">
                {{ compositionValueQuotation }}
              </p>
            </v-col>
            <v-col cols="12" class="pb-3">
              <v-divider />
            </v-col>
            <v-col cols="12">
              <p class="primary--text resume-cotation__title">
                PRAZOS
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Início Vigência
              </p>
              <p class="primary--text resume-cotation__title">
                {{ formatDateToDDMMYYYY(info.inicio_vigencia) }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4" class="pr-sm-5">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Termino Vigência
              </p>
              <p class="primary--text resume-cotation__title">
                {{ formatDateToDDMMYYYY(info.fim_vigencia) }}
              </p>
            </v-col>
            <v-col cols="12" sm="6" md="4">
              <p class="darkBluishGray--text mb-0 resume-cotation__text">
                Prazo (em dias)
              </p>
              <p class="primary--text resume-cotation__title">
                {{
                  intervalDates(
                    formatDateToDDMMYYYY(info.inicio_vigencia),
                    formatDateToDDMMYYYY(info.fim_vigencia)
                  )
                }}
              </p>
            </v-col>
            <v-col cols="12" class="pb-3">
              <v-divider />
            </v-col>
            <v-col cols="12" v-if="info.anexos.length > 0" class="mb-5">
              <p class="primary--text resume-cotation__title">
                DOCUMENTOS ANEXOS
              </p>
              <DocumentDataTable
                :documents="info.anexos"
                @preview-file="onPreviewFile"
                :disabled="true"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" sm="6" md="4" lg="3" class="pt-2" v-if="showButton">
          <BaseButton
            v-html="'EDITAR DADOS INSERIDOS'"
            outlined
            color="secondary"
            @click="viewEdit"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="12" class="pt-10 pb-8">
      <v-divider />
    </v-col>
  </v-row>
</template>
<script>
const mockFirstColumnResumeQuotation = [
  {
    title: "Tomador Matriz/Filial",
    value: "NOME DO TOMADOR MATRIZ/FILIAL"
  },
  {
    title: "Segurado",
    value: "NOME DO SEGURADO"
  },
  {
    title: "Tipo de Recurso",
    value: "EMBARGO"
  },
  {
    title: "Início de vigência",
    value: "DE 24HRS DE DD/MM/AAAA"
  }
];
const mockSecondColumnResumeQuotation = [
  {
    title: "CNPJ",
    value: "00.000.000/0000-00"
  },
  {
    title: "CPF",
    value: "000.000.000-00"
  },
  {
    title: "Importância Segurada",
    value: "R$ 0,00"
  },
  {
    title: "Término de vigência",
    value: "DE 24HRS DE DD/MM/AAAA"
  }
];
import { asMoneyString, formatDateToDDMMYYYY } from "@/utils/formats.js";
import * as BRUtils from "@brazilian-utils/brazilian-utils";
import { TokenService } from "@/api/storage.js";
import { intervalDates } from "@/utils/formats.js";
import DocumentsMixin from "@/mixins/DocumentsMixin";
import _ from "lodash";
import DocumentDataTable from "@/components/DocumentDataTable";
import LabelInputMixin from "@/mixins/LabelInputMixin";
export default {
  mixins: [DocumentsMixin, LabelInputMixin],
  data: () => ({
    isActiveResume: false,
    firstColumnResumeQuotation: mockFirstColumnResumeQuotation,
    secondColumnResumeQuotation: mockSecondColumnResumeQuotation,
    asMoneyString,
    formatDateToDDMMYYYY,
    BRUtils,
    intervalDates
  }),
  components: {
    DocumentDataTable
  },
  computed: {
    iconShowResume() {
      return this.isActiveResume ? "fa-chevron-up" : "fa-chevron-down";
    },
    isClient() {
      // Fazer uma validação para verificar se o cliente está vendo ou
      // é o funcionário lockton
      return TokenService.getTypeUser() != "funcionario";
    },
    valueQuotation() {
      return this.info.recursos[0]
        ? this.info.recursos[0].valor_importancia_segurada
        : this.info.valor_importancia_segurada;
    },
    officeName() {
      return _.get(this.info.escritorio, "nome_fantasia", "NENHUM");
    },
    compositionValueQuotation() {
      return this.info.recursos[0]
        ? this.info.recursos[0].tipo_recurso.nome
        : this.info.composicao_importancia_segurada;
    },
    internalNumber() {
      return this.info.numero_interno_cliente || "---";
    },
    courtName() {
      return (
        this.info.processo?.tribunal?.nome ||
        this.info.processo?.nome_tribunal ||
        "---"
      );
    },
    justiceRegionName() {
      return (
        this.info.processo?.unidade?.nome ||
        this.info.processo?.nome_unidade ||
        "---"
      );
    },
    numberProcess() {
      return _.get(this.info.processo, "numero_processo", "---");
    },
    typeProcess() {
      return _.get(this.info.processo, "tipo_processo.nome", "---");
    },
    neighborhoodInsured() {
      return _.get(this.info.segurado, "endereco.bairro", "---");
    },
    cityInsured() {
      return _.get(this.info.segurado, "endereco.cidade", "---");
    },
    stateInsured() {
      return _.get(this.info.segurado, "endereco.uf.nome", "---");
    },
    complementAddressInsured() {
      return _.get(this.info.segurado, "endereco.complemento", "---");
    },
    numberAddressInsured() {
      return _.get(this.info.segurado, "endereco.numero", "---");
    },
    addressInsured() {
      return _.get(this.info.segurado, "endereco.logradouro", "---");
    },
    zipCodeAddressInsured() {
      return _.get(this.info.segurado, "endereco.cep", "---");
    },
    isModalityJudicial() {
      return this.info.modalidade.id === "judicial";
    },
    typeEmission() {
      return `${_.get(this.info.tipo_emissao, "nome", "")} - ${_.get(
        this.info.submodalidade,
        "nome",
        ""
      )}`;
    }
  },
  mounted() {
    this.updateValues();
  },
  methods: {
    showResumeQuotation() {
      this.isActiveResume = !this.isActiveResume;
    },
    viewEdit() {
      this.$emit("changeView");
    },
    updateValues() {
      // Adotando esse sistema para diminuir meu html
      // porém preciso atualzar valores da primeira
      // e segunda coluna desse jeito
      this.firstColumnResumeQuotation[0].value = this.info.tomador.nome_fantasia;
      this.firstColumnResumeQuotation[1].value = this.info.segurado.nome;
      this.firstColumnResumeQuotation[2].value =
        this.info.recursos[0]?.tipo_recurso?.nome || "---";
      this.firstColumnResumeQuotation[3].value = `DE 24HRS DE ${formatDateToDDMMYYYY(
        this.info.inicio_vigencia
      )}`;
      this.secondColumnResumeQuotation[0].value = BRUtils.formatCNPJ(
        this.info.tomador.cnpj
      );
      if (this.info.segurado.tipo_pessoa.id == "pessoa_fisica") {
        this.secondColumnResumeQuotation[1].value = BRUtils.formatCPF(
          this.info.segurado.numero_documento
        );
        this.secondColumnResumeQuotation[1].title = "CPF";
      } else {
        this.secondColumnResumeQuotation[1].value = BRUtils.formatCNPJ(
          this.info.segurado.numero_documento
        );
        this.secondColumnResumeQuotation[1].title = "CNPJ";
      }
      this.secondColumnResumeQuotation[2].value = asMoneyString(
        this.info.recursos[0]?.valor_importancia_segurada ||
          this.info.valor_importancia_segurada
      );
      this.secondColumnResumeQuotation[3].value = `DE 24HRS DE ${formatDateToDDMMYYYY(
        this.info.fim_vigencia
      )}`;
    }
  },
  props: {
    info: {
      type: Object
    },
    showButton: {
      type: Boolean,
      default: true
    },
    showInfo: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="sass">
.resume-cotation__
  &container
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FFFFFF
  &title
    font-size: 14px
    font-weight: 700
  &text
    font-size: 12px
    font-weight: 500
</style>
